<div class="main">
    <ngx-spinner bdColor="rgba(51,51,51,0.55)"
                 size="medium"
                 color="#fff"
                 type="line-spin-clockwise-fade"
                 [fullScreen]="false">
        <p class="loading">{{ 'general.loading' | translate }}...</p>
    </ngx-spinner>
    <div class="row ml-0">
        <div class="col-12">
            <h2 class="page-title" tabindex="0">{{'setting.agents_in_field' | translate}}</h2>
        </div>
    </div>
    <hr>
    <div class="row m-1">
        <div class="col-12">
            <div class="d-flex flex-row bd-highlight float-right">
                <!-- Active/Inactive filter -->
                <div class="p-2 bd-highlight">
                    <span>{{'general.in_field' | translate}}</span><br>
                    <div ngbDropdown class="d-inline-block w-100">
                        <button class="btn btn-outline-secondary mr-1 bg-white w-100 text-dark"
                            title="{{ 'general.'+statusFilter.toLowerCase() | translate }}" id="status" ngbDropdownToggle>
                            {{ 'general.'+statusFilter.toLowerCase() | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="status">
                            <button ngbDropdownItem (click)="changeStatusFilterLabel(status)" 
                                title="{{ 'general.'+status.toLowerCase() | translate }}" *ngFor="let status of statuses">
                                {{ 'general.'+status.toLowerCase() | translate }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="p-2 bd-highlight">
                    <label class="mb-0" for="role">{{'roles.role' | translate}}</label><br>
                    <!--Role filter-->
                    <div ngbDropdown class="d-inline-block w-100">
                        <button class="btn btn-outline-secondary mr-1 bg-white w-100 text-dark"
                                title="{{ 'roles.'+roleFilter | translate }}" id="role" ngbDropdownToggle>
                            {{ 'roles.'+roleFilter | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                        </button>
                        <div ngbDropdownMenu>
                            <button ngbDropdownItem (click)="changeRoleLabel(role.name)"
                                    title="{{ 'roles.'+role.name | translate }}" *ngFor="let role of roles">
                                {{ role.name | translate }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="p-2 bd-highlight">
                    <label for="filter" class="mb-0">{{'general.filter_name_email' | translate}}</label>
                    <input type="text" id="filter" class="form-control rounded border-secondary" (keyup)="emptyInput()" maxlength="50">
                </div>
                <div class="mt-2 bd-highlight button-group">
                    <button class="btn remove-filter-btn ml-1" title="" (click)="clearFilter()">
                        <i class="fa fa-times fa-sm" title="{{ 'general.clear_filter' | translate }}"></i>
                    </button>
                    <button class="btn apply-filter-btn ml-1" title="" (click)="applyFilter()">
                        <i class="fa fa-filter fa-xs" title="{{ 'general.apply_filter' | translate }}"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row m-1">
        <div class="col-12">
            <table class="border-top" mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" matSortActive="profileFirstName" matSortDirection="asc" matSortDisableClear [attr.role]="null">
                <!-- Name Column -->
                <ng-container matColumnDef="profileFullName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'general.name' | translate}} </th>
                    <td class="text-break" mat-cell *matCellDef="let user" [attr.role]="null"> {{user.profileFullName}} </td>
                </ng-container>
                <!-- Email Column -->
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'general.email' | translate}} </th>
                    <td class="text-break" mat-cell *matCellDef="let user" [attr.role]="null"> {{user.email}} </td>
                </ng-container>
                <!-- In Field Column -->
                <ng-container matColumnDef="inField">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'general.in_field' | translate}} </th>
                    <td mat-cell *matCellDef="let user" [attr.role]="null" scope="row"> 
                        <i *ngIf="!user.inField" class="fa fa-circle text-danger red-text" title="{{'general.inactive' | translate}}"><span class="info-act-inact">&nbsp;{{'general.inactive' | translate}}</span></i>
                        <i *ngIf="user.inField" class="fa fa-circle green-text" title="{{'general.active' | translate}}"><span class="info-act-inact">&nbsp;{{'general.active' | translate}}</span></i>
                    </td>
                </ng-container>
                <!-- Role Column -->
                <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'general.role' | translate}} </th>
                    <td mat-cell *matCellDef="let user" [attr.role]="null"> {{'roles.'+user.role | translate}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator #paginator [pageIndex]="pageIndex" [length]="totalLength" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons (page)="nextPage($event)"></mat-paginator>
        </div>
    </div>
</div>